import { Component, Injector } from '@angular/core';
import { Validators } from '@angular/forms';
import {
  BaseResourceFormComponent, Favorecido, LoginContabil, GlobalService, FavorecidoService,
  Convenio, EddyAutoComplete, Recurso, DateFormatPipe, ConvenioPrestacao, UnidadeService,
  Unidade, ConvenioComissao, TipoConvenio, ConvenioHistorico, ConvenioAditamento
} from 'eddydata-lib';
import { ConvenioService } from '../service/convenio.service';
import { RecursoService } from '../../../contabil/recurso/service/recurso.service';
import { takeUntil } from 'rxjs/operators';
import { MessageService } from 'primeng/api';
import { ConvenioPrestacaoService } from '../service/convenio-prestacao.service';
import { ConvenioComissaoService } from '../convenio-comissao/service/convenio-comissao.service';
import { TipoConvenioService } from '../../tipo-convenio/service/tipo-convenio.service';
import * as toastr from 'toastr';
import { ConvenioHistoricoService } from '../service/convenio-historico.service';
import { ConvenioAditamentoService } from '../service/convenio-aditamento.service';

@Component({
  selector: 'lib-convenio-frm',
  templateUrl: './convenio-frm.component.html'
})
export class ConvenioFrmComponent extends BaseResourceFormComponent<Convenio, LoginContabil> {

  /**
   * Declaração de variáveis
   */
  public unidadeAutoComplete: EddyAutoComplete<Unidade>;
  public listaPrestacoes: Array<ConvenioPrestacao> = new Array<any>();
  public listaHistoricos: Array<ConvenioHistorico> = new Array<any>();
  public listaAditamentos: Array<ConvenioAditamento> = new Array<any>();
  public favorecidoAutoComplete: EddyAutoComplete<Favorecido>;
  public recursoAutoComplete: EddyAutoComplete<Recurso>;
  public aplicacaoAutoComplete: EddyAutoComplete<Recurso>;
  public listaComissoes: Array<ConvenioComissao> = new Array<any>();
  public listaTipoConvenio: TipoConvenio[];
  public listaTipoFavorecido: Array<any>;
  public listaOrigem: Array<any>;
  public listaEspecie: Array<any>;


  /**
   * Construtor com as injeções de dependencias
   */
  constructor(
    protected injector: Injector,
    protected messageService: MessageService,
    protected globalService: GlobalService,
    protected prestacaoService: ConvenioPrestacaoService,
    protected unidadeService: UnidadeService,
    protected convenioService: ConvenioService,
    protected comissaoService: ConvenioComissaoService,
    protected historicoService: ConvenioHistoricoService,
    protected aditamentoService: ConvenioAditamentoService,
    protected recursoService: RecursoService,
    protected tipoConvenioService: TipoConvenioService,
    protected favorecidoService: FavorecidoService) {
    super(new Convenio(), injector, Convenio.converteJson, convenioService);
  }

  // ========================================================================
  //                        MÉTODOS ABSTRAÍDOS
  // ========================================================================

  protected criarCamposForm(): void {
    this.entidadeForm = this.fb.group({
      id: [null],
      numero: [null, [Validators.required]],
      ano: [this.login.exercicio.ano, Validators.required],
      unidade: [null, [Validators.required]],
      convenente: ['', [Validators.required]],
      processo: ['', [Validators.required]],
      especie: ['D', [Validators.required]],
      origem: [null, [Validators.required]],
      siconv: [null],
      objeto: [null, [Validators.required]],
      finalidade: [null, [Validators.required]],
      aditivo: [null],
      lei_numero: [null],
      tipo_convenio: ['4', [Validators.required]],
      legislacao: ['2', [Validators.required]],
      enviar_email: [null],
      autorizacao: ['', [Validators.required]],
      data_assinatura: [null, [Validators.required]],
      data_contabilizacao: [null, [Validators.required]],
      data_inicio: [null, [Validators.required]],
      data_termino: [null],
      data_prestacao: [null],
      data_quitacao: [null],
      tipo_fornecedor: [null, [Validators.required]],
      valor_convenio: 0,
      valor_contrapartida: 0,
      saldo_anterior: [null],
      valor_aplicacao: [null],
      valor_devolvido: [null],
      valor_outros: [null],
      valor_recurso: [null],
      recurso: [null, [Validators.required]],
      aplicacao: [null, [Validators.required]],
      favorecido: [null, [Validators.required]],
      orgao: [this.login.orgao, [Validators.required]],
      exercicio: [this.login.exercicio, [Validators.required]],
      parente: [null],
      prestacoes: [null],
      comissoes: [null],
      historicos: [null],
      aditamentos: [null],
    });
  }

  protected afterLoad() {
    this.entidade.data_assinatura = new DateFormatPipe().transform(this.entidade.data_assinatura, []);
    this.entidade.data_inicio = new DateFormatPipe().transform(this.entidade.data_inicio, []);
    this.entidade.data_termino = new DateFormatPipe().transform(this.entidade.data_termino, []);
    this.entidade.data_contabilizacao = new DateFormatPipe().transform(this.entidade.data_contabilizacao, []);
    this.favorecidoAutoComplete.id = this.entidade.favorecido ? this.entidade.favorecido.id : null;
    this.recursoAutoComplete.id = this.entidade.recurso ? this.entidade.recurso.id : null;
    this.aplicacaoAutoComplete.id = this.entidade.aplicacao ? this.entidade.aplicacao.id : null;
    if (!this.podeAlterar(this.entidade.data_contabilizacao)) {
      this.entidadeForm.get('data_contabilizacao').disable();
      this.entidadeForm.get('data_assinatura').disable();
      this.entidadeForm.get('valor_convenio').disable();
      this.entidadeForm.get('valor_contrapartida').disable();
      this.entidadeForm.get('origem').disable();
      this.entidadeForm.get('tipo_convenio').disable();
      this.entidadeForm.get('tipo_fornecedor').disable();
      this.entidadeForm.get('numero').disable();
    }
    const param = {};
    param['convenio.id'] = this.entidade.id;
    this.prestacaoService.filtrar(0, -1, {
      'convenio.id': this.entidade.id,
      relations: 'exercicio,pagamento,pagamento.liquidacao,pagamento.liquidacao.empenho,pagamento.liquidacao.empenho.exercicio,recebimento,recebimento.ficha,recebimento.ficha.receita,usuario'
    }).pipe(takeUntil(this.unsubscribe))
      .subscribe(
        (data: any) => {
          this.listaPrestacoes = data ? data.content : new Array<ConvenioPrestacao>();
        }, error => this.messageService.add({ severity: 'error', summary: 'Atenção', detail: error }));

    this.comissaoService.filtrar(0, -1, param).pipe(takeUntil(this.unsubscribe))
      .subscribe(
        (data: any) => {
          this.listaComissoes = data ? data.content : new Array<ConvenioComissao>();
        }, error => this.messageService.add({ severity: 'error', summary: 'Atenção', detail: error }));
    this.historicoService.filtrar(0, -1, param).pipe(takeUntil(this.unsubscribe))
      .subscribe(
        (data: any) => {
          this.listaHistoricos = data ? data.content : new Array<ConvenioHistorico>();
        }, error => this.messageService.add({ severity: 'error', summary: 'Atenção', detail: error }));
    this.aditamentoService.filtrar(0, -1, {
      'convenio.id': this.entidade.id,
      relations: 'convenio,convenio.tipo_convenio,exercicio'
    }).pipe(takeUntil(this.unsubscribe))
      .subscribe(
        (data: any) => {
          this.listaAditamentos = data ? data.content : new Array<ConvenioAditamento>();
        }, error => this.messageService.add({ severity: 'error', summary: 'Atenção', detail: error }));

  }

  protected parametrosExtras(): {} {
    return { relations: 'favorecido,favorecido.tipo,orgao,recurso,aplicacao,unidade,tipo_convenio' };
  }

  protected afterInit(): void {
    this.carregarAutoCompletes();
    this.listaTipoFavorecido = [
      { nome: 'FORNECEDOR', id: 'F' },
      { nome: 'CREDOR', id: 'C' }
    ];
    this.listaOrigem = [
      { nome: 'ESTADUAL', id: 'E' },
      { nome: 'FEDERAL', id: 'F' }
    ];
    this.listaEspecie = [
      { nome: 'CHAMAMENTO', id: 'C' },
      { nome: 'DISPENSA', id: 'D' },
      { nome: 'INEXIGIBILIDADE', id: 'I' },
      { nome: 'OUTROS', id: 'O' }
    ];
    this.tipoConvenioService.filtrar(0, 0, { orgao_id: this.login.orgao.id }).pipe(takeUntil(this.unsubscribe))
      .subscribe((res) => {
        this.listaTipoConvenio = res ? res.content : [];
      }, error => toastr.error(error.message ? error.message : error));
  }

  protected beforeSubmit(): void {
    try {

      if (!this.entidadeForm.get('data_contabilizacao').value) {
        throw new Error(`Informe a data de contabilização!`);
      }
      if (!this.entidadeForm.get('numero').value) {
        throw new Error(`Informe o número do convênio!`);
      }
      if (!this.entidadeForm.get('data_assinatura').value) {
        throw new Error(`Informe a data de assinatura!`);
      }
      if (!this.entidadeForm.get('favorecido').value) {
        throw new Error(`Informe o favorecido!`);
      }
      if (!this.entidadeForm.get('finalidade').value) {
        throw new Error(`Informe a finalidade!`);
      }
      if (!this.entidadeForm.get('convenente').value) {
        throw new Error(`Informe o convenente!`);
      }
      if (!this.entidadeForm.get('data_inicio').value) {
        throw new Error(`Informe a data de inicio!`);
      }
      if (!this.entidadeForm.get('processo').value) {
        throw new Error(`Informe o número processo!`);
      }
      if (!this.entidadeForm.get('favorecido').value) {
        throw new Error(`Informe o favorecido para o convênio!`);
      }
      if (this.entidadeForm.get('valor_convenio').value && +this.entidadeForm.get('valor_convenio').value == 0) {
        throw new Error(`Informe o valor do convênio`);
      }

      if (!this.podeAlterar(this.entidadeForm.get('data_contabilizacao').value) && !this.entidade.id) {
        throw new Error(`Data de contabilização não pode se inferior a ${this.login['dias_bloquear_alteracoes']} dia(s)`);
      }

      this.entidadeForm.get('prestacoes').setValue(this.listaPrestacoes);
      this.entidadeForm.get('historicos').setValue(this.listaHistoricos);
      this.entidadeForm.get('comissoes').setValue(this.listaComissoes);
      this.entidadeForm.get('aditamentos').setValue(this.listaAditamentos);
    } catch (e) {
      this.messageService.add({ severity: 'warn', summary: 'Validação', detail: e });
      throw e;
    }
  }

  protected afterSubmit(entidade: Convenio): void {
    this.loadResource();
    window.scrollTo(0, 0);
  }

  private carregarAutoCompletes() {
    // autocomplete para unidade
    this.unidadeAutoComplete = new EddyAutoComplete(this.entidadeForm.get('unidade'), this.unidadeService,
      'id', ['codigo', 'nome'], { ppa_id: this.login.ppa.id, orderBy: 'nome' }, { number: ['codigo'], text: ['nome'] }
    );

    // autocomplete para favorecido
    this.favorecidoAutoComplete = new EddyAutoComplete(this.entidadeForm.get('favorecido'), this.favorecidoService,
      'id', ['cpf_cnpj', 'nome'], { cidade_id: this.login.cidade.id, relations: 'tipo', orderBy: 'nome' }, { number: ['id', 'cpf_cnpj'], text: ['nome'] }
    );
    // autocomplete para recurso
    this.recursoAutoComplete = new EddyAutoComplete(this.entidadeForm.get('recurso'), this.recursoService,
      'id', ['codigo', 'nome'], { nivel: 0, cidade_id: this.login.cidade.id, orderBy: 'nome' }, { number: ['id', 'codigo'], text: ['nome'] }
    );
    // autocomplete para aplicacao
    this.aplicacaoAutoComplete = new EddyAutoComplete(this.entidadeForm.get('aplicacao'), this.recursoService,
      'id', ['codigo', 'nome'], { nivel: 1, cidade_id: this.login.cidade.id, orderBy: 'nome' }, { number: ['id', 'codigo'], text: ['nome'] }
    );

  }

}
